import type * as Blockly from 'blockly/core';
import { expr, registerSetupCode, resolveAnalogPin } from '@/(routers)/boards/editor/block/generators/arduino/_gen';
import { markPercentUsed } from '@/(routers)/boards/editor/block/generators/arduino/blocks/sensing/helper/analog_helper';

export const brightnessHelperCode = `float _sbeGetBrightness(int pinNumber, int res, float vol) {
  float cds_ad = analogRead(pinNumber);
  float cds_v = cds_ad * vol / res;
  float v_res = vol - cds_v;
  if (v_res < 0.01) {
    v_res = 0.01;
  }
  return 10000 * cds_v / v_res / 1000;
}\n`;

let _used = false;

export function brightnessUsed(): boolean {
    return _used;
}

export function resetBrightness(): void {
    _used = false;
}

export function register(gen: any): void {
    gen.forBlock['brightness'] = function (block: Blockly.Block): [string, number] {
        const { pin, config } = resolveAnalogPin(block);
        const readMode = block.getFieldValue('READ_MODE');

        registerSetupCode(pin, `  pinMode(${pin}, INPUT);\n`);

        if (readMode === 'PERCENT') {
            markPercentUsed();
            return expr(`_sbeGetPercent(${pin}, ${config.analogRes})`);
        }

        if (readMode === 'BRIGHTNESS') {
            _used = true;
            return expr(`_sbeGetBrightness(${pin}, ${config.analogRes}, ${config.analogVol})`);
        }

        return expr(`analogRead(${pin})`);
    };
}
